import AxiosInstance from "../config/axiosInterceptor";
import { statusArr } from "../config/AppConstants";
import { ContentApiRoutes } from "../../navigation/NavConstant";
import { SingerFields } from "../../view/Modules/Singers/SingerDataTypes";
import { ComposerFields } from "../../view/Modules/Composers/ComposerDataTypes";
import { ActorFields } from "../../view/Modules/Actors/ActorDataTypes";
import { BrandFields } from "../../view/Modules/Brands/BrandDataTypes";
import { CampaignFields } from "../../view/Modules/Campaigns/CampaignDataTypes";

export const HelperServices = {
  getCountries: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.COUNTRIES, { params }),
  getAllValidCountries: () =>
    AxiosInstance.get(
      ContentApiRoutes.COUNTRIES + "?pagination=0&status=" + statusArr.active
    ),
  getStates: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.STATES, { params }),

  getAllValidStates: (params?: any) => {
    const url =
      ContentApiRoutes.STATES + "?pagination=0&status=" + statusArr.active;
    return AxiosInstance.get(url, {
      params,
      cache: {
        maxAge: 30 * 60 * 1000, // 2 min instead of 15 min
        exclude: { query: false },
      },
    });
  },
  viewArea: (params?: any) => {
    const url = ContentApiRoutes.AREAS + "/" + params;
    return AxiosInstance.get(url);
    // return AxiosInstance.get(url, {
    //   params,
    //   cache: {
    //     maxAge: 30 * 60 * 1000, // 2 min instead of 15 min
    //     exclude: { query: false },
    //   },
    // });
  },
  viewBuilding: (params?: any) => {
    const url = ContentApiRoutes.BUILDINGS + "/" + params;
    return AxiosInstance.get(url);
    // return AxiosInstance.get(url, {
    //   params,
    //   cache: {
    //     maxAge: 30 * 60 * 1000, // 2 min instead of 15 min
    //     exclude: { query: false },
    //   },
    // });
  },

  getCompanyTypes: (params?: any) => {
    const url =
      ContentApiRoutes.COMPANY_TYPES +
      "?pagination=0&status=" +
      statusArr.active;
    return AxiosInstance.get(url, {
      params,
      cache: {
        maxAge: 30 * 60 * 1000, // 2 min instead of 15 min
        exclude: { query: false },
      },
    });
  },
  getCreatedByList: (params?: any) => {
    const url = ContentApiRoutes.CREATED_BY_LIST + "?pagination=0";
    return AxiosInstance.get(url, {
      params,
    });
  },
  getCities: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.CITIES, { params }),
  getAllValidCities: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.CITIES + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  getAreas: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.AREAS, { params }),
  addArea: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.ADD_AREA, params),
  updateArea: (params: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_AREA + params.id + "?_method=PUT",
      params
    ),
  getAllValidAreas: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.AREAS + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  getAllAdminThemes: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.AADMIN_THEMES +
        "?pagination=0&sort_by=theme_title&status=" +
        statusArr.active,
      {
        params,
      }
    ),
  addBuilding: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.ADD_BUILDING, params),
  updateBuilding: (params: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_BUILDING + params.id + "?_method=PUT",
      params
    ),
  getBuildings: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.BUILDINGS, { params }),
  getAllValidBuildings: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.BUILDINGS + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  getActors: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.ACTORS, { params }),
  createActor: (data: ActorFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_ACTOR, data),
  updateActor: (id: number, data: ActorFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_ACTOR.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  deleteActor: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_ACTOR.replace(":id", id.toString())
    ),
  getBrands: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.BRANDS, { params }),
  getAllValidBrands: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.BRANDS + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  createBrand: (data: BrandFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_BRAND, data),
  updateBrand: (id: number, data: BrandFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_BRAND.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  deleteBrand: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_BRAND.replace(":id", id.toString())
    ),
  getCampaigns: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.CAMPAIGNS, { params }),
  getAllValidCampaigns: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.CAMPAIGNS + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  createCampaign: (data: CampaignFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_CAMPAIGN, data),
  updateCampaign: (id: number, data: CampaignFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_CAMPAIGN.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  deleteCampaign: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_CAMPAIGN.replace(":id", id.toString())
    ),
  getComposers: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.COMPOSERS, { params }),
  createComposer: (data: ComposerFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_COMPOSER, data),
  updateComposer: (id: number, data: ComposerFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_COMPOSER.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  deleteComposer: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_COMPOSER.replace(":id", id.toString())
    ),
  getEras: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.ERAS, { params }),
  getAllValidEras: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.ERAS + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  getEvents: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.EVENTS, { params }),
  getAllValidEvents: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.EVENTS + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  getFestiveSeasons: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.FESTIVE_SEASONS, { params }),
  getAllValidFestiveSeasons: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.FESTIVE_SEASONS +
        "?pagination=0&status=" +
        statusArr.active,
      {
        params,
      }
    ),
  getGenres: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.GENRES, { params }),
  getAllValidGenres: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.GENRES + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  getLabels: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.LABELS, { params }),
  getAllValidLabels: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.LABELS + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  addLabel: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_LABEL, params),
  updateLabel: (params: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_LABEL + params.id + "?_method=PUT",
      params
    ),
  deleteLabel: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_LABEL.replace(":id", id.toString())
    ),
  getLanguages: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.LANGUAGES, { params }),
  getAllValidLanguages: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.LANGUAGES + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  getLicenses: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.LICENSES, { params }),
  getAllValidLicenses: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.LICENSES + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  getLyricists: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.LYRICISTS, { params }),
  createLyricist: (data: ComposerFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_LYRICIST, data),
  updateLyricist: (id: number, data: ComposerFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_LYRICIST.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  deleteLyricist: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_LYRICIST.replace(":id", id.toString())
    ),
  getMoods: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.MOODS, { params }),
  getAllValidMoods: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.MOODS + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  getRatingCharts: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.RATING_CHARTS, { params }),
  getAllValidRatingCharts: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.RATING_CHARTS +
        "?pagination=0&status=" +
        statusArr.active,
      {
        params,
      }
    ),
  getSingers: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.SINGERS, { params }),
  createSinger: (data: SingerFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_SINGER, data),
  updateSinger: (id: number, data: SingerFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_SINGER.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  deleteSinger: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_SINGER.replace(":id", id.toString())
    ),
  getTempos: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.TEMPOS, { params }),
  getAllValidTempos: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.TEMPOS + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
};
